export const ModalFX = () => {

  var elements = {
    target: 'data-target',
    active: 'is-active',
    button: '.modal-button',
    close: '.modal-close',
    buttonClose: '.modal-button-close',
    background: '.modal-background'
  };

  var onClickEach = function (selector, callback) {
    var arr = document.querySelectorAll(selector);
    arr.forEach(function (el) {
      el.addEventListener('click', callback);
    });
  };

  var events = function () {
    console.log('Modal init!');

    onClickEach(elements.button, openModal);
    onClickEach(elements.close, closeModal);
    onClickEach(elements.buttonClose, closeAll);
    onClickEach(elements.background, closeModal);

    // Close all modals if ESC key is pressed
    document.addEventListener('keyup', function (key) {
      if (key.keyCode === 27) {
        closeAll();
      }
    });
    //ページ再訪時はモーダルを閉じる
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        closeAll();
      }
    });


  };

  var closeAll = function () {
    console.log('close all');
    var openModal = document.querySelectorAll('.' + elements.active);
    openModal.forEach(function (modal) {
      modal.classList.remove(elements.active);
    });
    unFreeze();
  };


  var openModal = function () {
    var modal = this.getAttribute(elements.target);
    freeze();
    document.getElementById(modal).classList.add(elements.active);
  };

  var closeModal = function () {
    var modal = this.parentElement.id;
    document.getElementById(modal).classList.remove(elements.active);
    unFreeze();
  };

  // Freeze scrollbars
  var freeze = function () {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflowY = "scroll";
  };

  var unFreeze = function () {
    document.documentElement.style.overflow = "";
    document.body.style.overflowY = "";
  };

  return {
    init: function () {
      events();
      //もし#gf_navが存在したら、モーダルの高さから#gf_navの高さを引く
      const gfNav = document.getElementById('gf_nav');
      if (gfNav) {
        const gfNavHeight = gfNav.clientHeight;
        const modals = document.querySelectorAll('.modal');
        modals.forEach(function (modal) {
          //modalがgf_menu_modalじゃなかったら、
          if (modal.id !== `gf_menu_modal`){
            modal.style.marginBottom = gfNavHeight + 'px';
          }
        });

      }



    }
  };
};